import { render } from "./tradeInTheOld.vue?vue&type=template&id=74613f28&scoped=true"
import script from "./tradeInTheOld.vue?vue&type=script&lang=js"
export * from "./tradeInTheOld.vue?vue&type=script&lang=js"

import "./tradeInTheOld.vue?vue&type=style&index=0&id=74613f28&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74613f28"]])

export default __exports__